<div class="w-full h-full flex-center-center flex-col">
    <img src="/assets/imgs/no-data/no-data.png" alt="" class="h-32" />
    <div class="text-sm text-sub-text">{{text || 'No Data'}}</div>
</div>
